import request from './request';

export async function fetchHome(params) {
  return await request('get', '/apiv2/explore', params);
}

export async function fetchNews(params) {
  return await request('get', '/apiv2/feed', params);
}

export async function fetchPetitions(params) {
  return await request('get', '/apiv2/petitions', params);
}

export async function fetchCampaigns(params) {
  //not used right now... just copy pasted the cp-explore-campaigns-form into the feed.
}

export async function fetchBlogs(params) {
  return await request('get', '/apiv2/blogs', params);
}

export async function fetchInvitingUser(params) {
  return await request('get', '/apiv2/user/search-inviting-user', params);
}

export async function fetchRaces(params) {
  return await request('get', '/apiv2/races', params);
}

export async function fetchLobbying(params) {
  return await request('get', '/apiv2/lobbying', params);
}

export async function fetchPolls(params) {
  return await request('get', '/apiv2/polls', params);
}

export async function fetchEvents(params) {
  return await request('get', `/apiv2/events`, params);
}

export async function getPersonalData(params) {
  return await request('get', `/apiv2/explore/personal-data`, params);
}
